import React from 'react'
import ScopedDate from '../../date/scoped'

const Date = ({
    value
}) => {

    return (
        <div
            style={{
                display: 'flex',
                flexDirection: 'row',
                justifyContent: 'space-around',
                color: 'rgb(110, 110, 110)'
            }}
        >
            <small>
                <ScopedDate value={value} />
            </small>
        </div>
    )
}

export default Date
